import { KitStatus, TestStatus } from '../../../models/customerOverview';
import { colors } from '../../../styles/colors';

export const DIALS: Dial[] = [
  {
    id: 1,
    kitStatus: 'lab',
    color: colors.yellow,
    title: 'cmp.overview.sampleAtLabNotRegistered',
    quantity: '',
  },
  {
    id: 2,
    kitStatus: 'activated',
    color: colors.blue,
    title: 'cmp.overview.sampleRegisteredNotAtLab',
    quantity: '',
  },
  {
    id: 3,
    kitStatus: 'ready',
    color: colors.lightBlue,
    title: 'cmp.overview.sampleAtLabRegistered',
    quantity: '',
  },
  {
    id: 4,
    kitStatus: 'rejected',
    color: colors.red,
    title: 'cmp.overview.rejected',
    quantity: '',
  },
  {
    id: 5,
    kitStatus: 'ready',
    testStatus: 'report-ready',
    color: colors.green,
    title: 'cmp.overview.reportReady',
    quantity: '',
  },
];

/*
{
        id: 5,
        kitStatus: 'ready',
        testStatus: 'report-ready',
        color: colors.lightSkyBlue,
        title: 'cmp.overview.reportReleased',
        quantity: '',
    },
*/

export type Dial = {
  id: number,
  kitStatus: KitStatus;
  testStatus?: TestStatus;
  color: string;
  title: string;
  quantity: string | number;
};

export type KitOverviewResponse = {
  kit: {
    status: KitStatus;
    count: string;
  }[];
  tests: {
    status: TestStatus;
    count: string;
  }[];
};
